export const BATCH_PRIORITY = [
    {
        name: 'Tất cả',
        value: '',
    },
    {
        name: 'Rất gấp',
        value: '3'
    },
    {
        name: 'Gấp',
        value: '2'
    },
    {
        name: 'Bình thường',
        value: '1'
    }
]
